(() => {
	const toggleClass = (element, className, action) => {
		if (!document.querySelector(element)) return;
		switch (action) {
			case 'add':
				document.querySelector(element).classList.add(className);
				break;
			case 'remove':
				document.querySelector(element).classList.remove(className);
				break;
		}
	};

	const setStickyheaderClass = () => {

		const headers = document.querySelectorAll('header .header');

		headers.forEach(header => {
			const mainheader = header.querySelector('.header__container');
			const stickyHeader = header.querySelector('.header__stickyheader-container');

			if (window.scrollY > mainheader.offsetHeight) {
				stickyHeader.classList.add('stickyheader');
				mainheader.classList.add('header--outofview');
				toggleClass('.megamenu-wrapper', 'stickyheader', 'add');
			} else {
				stickyHeader.classList.remove('stickyheader');
				mainheader.classList.remove('header--outofview');
				toggleClass('.megamenu-wrapper', 'stickyheader', 'remove');
			}
			if(window.getComputedStyle(header, null).display !== 'none') {
				if(stickyHeader.classList.contains('stickyheader')) {
					document.documentElement.style.setProperty('--sticky-header-height', `${stickyHeader.offsetHeight}px`);
				} else {
					document.documentElement.style.setProperty('--sticky-header-height', '0px');
				}
			}
		});
	};

	const offset = el => {
		var rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return { 
			top: rect.top + scrollTop, 
			left: rect.left + scrollLeft 
		};
	};

	if(!document.body.classList.contains('disable-sticky-header')) {
		window.addEventListener('scroll', setStickyheaderClass);
		setStickyheaderClass();
	}

	const searchbox = document.querySelector('.searchbox__input');
	if(searchbox) {
		searchbox.addEventListener('mouseout', function () {
			this.setAttribute('placeholder', searchbox.dataset.placeholder);
		});
		searchbox.addEventListener('mouseover', function () {
			this.setAttribute('placeholder', searchbox.dataset.hoverplaceholder);
		});
	}

	const addedmenuItems = document.querySelectorAll('.addedmenu__item');
	addedmenuItems.forEach(addedmenuItem => {
		const addedMenuSubmenu = addedmenuItem.querySelector('.addedmenu__submenu');
		if(addedMenuSubmenu) {
			const tempHeight = addedMenuSubmenu.offsetHeight;
			const tempWidth = addedMenuSubmenu.offsetWidth;
			const positionLeft = offset(addedMenuSubmenu).left;
			const outOfWindowValue = positionLeft + tempWidth;
			const outOfWindowBool = outOfWindowValue > window.innerWidth ? 'right' : 'left';
			
			addedMenuSubmenu.style.height = '0px';
			
			addedmenuItem.addEventListener('mouseover', function () {
				addedmenuItem.classList.add('show_submenu');
				addedMenuSubmenu.style.height = tempHeight + 'px';
				addedMenuSubmenu.classList.add(outOfWindowBool);
			});
			
			addedmenuItem.addEventListener('mouseout', function () {
				addedmenuItem.classList.remove('show_submenu');
				addedMenuSubmenu.style.height = '0px';
			});
		}
	});

	/*
		const mcHeaderHamburgerMenu = document.querySelector('.mc-header__hamburger-menu');
		if(mcHeaderHamburgerMenu) {	
			const headerHeight = document.querySelector('.mc-header--desktop').offsetHeight;
			mcHeaderHamburgerMenu.style.top = headerHeight + 'px';
		}
	*/

	// Emit megamenu from other components
	// Get all menu items with data-megamenu attribute
	const menulinks = document.querySelectorAll('.mc-header__main-menu-link[data-megamenu]');

	menulinks.forEach(menulink => {
		menulink.addEventListener('click', function(event) {
			// Send signal to AppMenu.vue file
			window.EventBus.$emit('open-megamenu', {
				item: {
					action: 'megamenu',
					id: event.target.dataset.megamenu
				},
				event
			});

		});
	});

})();
